import { render, staticRenderFns } from "./PageBreakV1.vue?vue&type=template&id=5119c07a&scoped=true&"
import script from "./PageBreakV1.vue?vue&type=script&lang=js&"
export * from "./PageBreakV1.vue?vue&type=script&lang=js&"
import style0 from "./PageBreakV1.vue?vue&type=style&index=0&id=5119c07a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119c07a",
  null
  
)

export default component.exports